import { ExtraOptions } from '@angular/router';

export const appRouterOptions: ExtraOptions = {
  paramsInheritanceStrategy: 'emptyOnly'
};
